import userService from "../api/server/clientSettingsService";
export const CLIENT_SETTINGS_NAMESPACE = "clientSettingsModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/clientSettingsService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(userService)
};

const state = {
  savingClient: false,
  clients: [],
  optionList: [],
  selectedClient: { Address: {} },
  billingStructureOptions: [],
  billingLineItems: [],
  defaultScripts: [],

  loadingClients: false,
  loadingOptionsList: false,
  loadingBillingStructures: false,
  loadingBillingLineItems: false,
  loadingClientDetail: false,
  loadingScriptTypes: false
};

const actions = {
  async loadClients(context, data) {
    var api = await services.api;
    context.state.loadingClients = true;
    context.commit("SET_CLIENT_LIST", []);
    return api.loadClients().then(response => {
      context.commit("SET_CLIENT_LIST", response);
      context.state.loadingClients = false;
    });
  },
  async loadOptionsList(context) {
    context.state.loadingOptionsList = true;
    context.commit("SET_OPTION_LIST", []);
    var api = await services.api;
    return api.loadOptionsList().then(response => {
      context.state.loadingOptionsList = false;
      context.commit("SET_OPTION_LIST", response);
    });
  },
  async loadBillingStructures(context) {
    context.state.loadingBillingStructures = true;
    var api = await services.api;
    return api.loadBillingStructures().then(response => {
      context.state.loadingBillingStructures = false;
      context.commit("SET_BILLING_STRUCTURE_LIST", response);
    });
  },
  async loadBillingLineItems(context) {
    context.state.loadingBillingLineItems = true;
    var api = await services.api;
    return api.loadBillingLineItems().then(response => {
      context.state.loadingBillingLineItems = false;
      context.commit("SET_BILLING_LINE_ITEMS", response);
    });
  },
  async loadScriptTypes(context) {
    context.state.loadingScriptTypes = true;
    var api = await services.api;
    return api.loadScriptTypes().then(response => {
      context.state.loadingScriptTypes = false;
      context.commit("SET_DEFAULT_SCRIPTS_LIST", response);
    });
  },
  async saveClientOptions(context, data) {
    var api = await services.api;
    return api.saveClientOptions(data);
  },
  async saveClientDetails(context, client) {
    var api = await services.api;
    context.state.savingClient = true;
    return api
      .saveClientDetails(client)
      .then(() => {
        context.state.savingClient = false;
      })
      .catch(e => {
        context.state.savingClient = false;
      });
  },
  async loadClientDetails(context, clientId) {
    var api = await services.api;
    context.state.loadingClientDetail = true;
    context.commit("SET_SELECTED_CLIENT", { Address: {} });
    return api.loadClientDetails(clientId).then(response => {
      context.state.loadingClientDetail = false;
      return context.commit("SET_SELECTED_CLIENT", response);
    });
  },
  selectClient(context, data) {
    context.commit("SET_SELECTED_CLIENT", {});
  }
};

const mutations = {
  SET_BILLING_STRUCTURE_LIST(storeState, data) {
    storeState.billingStructureOptions = data;
  },
  SET_DEFAULT_SCRIPTS_LIST(storeState, data) {
    storeState.defaultScripts = data;
  },
  SET_BILLING_LINE_ITEMS(storeState, data) {
    storeState.billingLineItems = data;
  },
  SET_CLIENT_LIST(storeState, data) {
    storeState.clients = data.sort(function(a, b) {
      return a.Name.toLowerCase() > b.Name.toLowerCase()
        ? 1
        : b.Name.toLowerCase() > a.Name.toLowerCase()
        ? -1
        : 0;
    });
  },
  SET_OPTION_LIST(storeState, data) {
    storeState.optionList = data.sort(function(a, b) {
      return a.Name.toLowerCase() > b.Name.toLowerCase()
        ? 1
        : b.Name.toLowerCase() > a.Name.toLowerCase()
        ? -1
        : 0;
    });
  },
  SET_SELECTED_CLIENT(storeState, data) {
    if (!data.Locations) data.Locations = [];
    data.Locations.forEach(x => {
      if (!x.InvoiceSettings) x.InvoiceSettings = {};
    });
    if (!data.Options) data.Options = [];
    if (!data.Address) data.Address = {};
    if (!data.BillingLineItems) data.BillingLineItems = [];
    if (!data.InvoiceSettings) data.InvoiceSettings = {};
    if (!data.BillingOptions) data.BillingOptions = {};
    if (!data.CallOptions) data.CallOptions = { Reminders: [] };
    storeState.selectedClient = data;
  },
  async SAVE_USER(storeState, data) {
    var api = await services.api;
    return api.save(data).then(res => {
      var index = -1;
      var updatedUser = data;
      updatedUser.Password = null;
      updatedUser.SendEmail = null;
      // -- splice in the modified user
      for (var i = 0; i < storeState.users.length; i++) {
        if (storeState.users[i].Id === updatedUser.Id) {
          index = i;
          break;
        }
      }
      if (index !== -1) {
        storeState.users.splice(index, 1, updatedUser);
      } else {
        storeState.users.push(updatedUser);
      }
      storeState.selectedClient = {};
    });
  }
};

const getters = {
  billingLineItems: storeState => storeState.billingLineItems,
  billingStructureOptions: storeState => storeState.billingStructureOptions,
  clients: storeState => storeState.clients,
  optionList: storeState => storeState.optionList,
  selectedClient: storeState => storeState.selectedClient,
  defaultScripts: storeState => storeState.defaultScripts,
  loadingClients: storeState => storeState.loadingClients,
  loadingOptionsList: storeState => storeState.loadingOptionsList,
  loadingBillingStructures: storeState => storeState.loadingBillingStructures,
  loadingBillingLineItems: storeState => storeState.loadingBillingLineItems,
  loadingClientDetail: storeState => storeState.loadingClientDetail,
  loadingScriptTypes: storeState => storeState.loadingScriptTypes,
  savingClient: storeState => storeState.savingClient
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
